import { render, staticRenderFns } from "./IndividualProfileUpdate.vue?vue&type=template&id=036bd5a2&scoped=true"
import script from "./IndividualProfileUpdate.vue?vue&type=script&lang=js"
export * from "./IndividualProfileUpdate.vue?vue&type=script&lang=js"
import style0 from "./IndividualProfileUpdate.vue?vue&type=style&index=0&id=036bd5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036bd5a2",
  null
  
)

export default component.exports